const HOST_BY_APP_KEY = "agent-os.studio-host-by-app";

function readMap(): Record<string, string> {
  try {
    const raw = window.localStorage.getItem(HOST_BY_APP_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object") return {};
    return parsed as Record<string, string>;
  } catch {
    return {};
  }
}

export function rememberStudioHostForApplication(
  applicationKey: string,
  agentId: string,
): void {
  const key = applicationKey.trim();
  const host = agentId.trim();
  if (!key || !host) return;
  const next = { ...readMap(), [key]: host };
  try {
    window.localStorage.setItem(HOST_BY_APP_KEY, JSON.stringify(next));
  } catch {
    // Embedded and test runtimes may expose localStorage without backing it.
  }
}

export function lastStudioHostForApplication(
  applicationKey: string,
): string | null {
  const host = readMap()[applicationKey.trim()];
  return host?.trim() || null;
}

export function resolveStudioHostAgentId(input: {
  chatAgentId?: string | null;
  applicationKey?: string | null;
  memberAgentIds?: string[];
  fallbackAgentId?: string | null;
}): string | null {
  const chat = input.chatAgentId?.trim();
  if (chat) return chat;
  if (input.applicationKey) {
    const remembered = lastStudioHostForApplication(input.applicationKey);
    if (remembered) return remembered;
  }
  const members = (input.memberAgentIds ?? []).map((id) => id.trim()).filter(Boolean);
  if (members[0]) return members[0];
  return input.fallbackAgentId?.trim() || null;
}
